module.exports = __webpack_public_path__ + "static/img/system-1.499d8c6f.png";